// Element: Icon
// Desc: loader

document.addEventListener("DOMContentLoaded", function() {
  var icons = document.getElementsByTagName("ov-icon");
  for (var i = 0; i < icons.length; i++) {
    var icon = icons[i];
    var iconPath = icon.getAttribute("icon");
    var iconSize = icon.getAttribute("size");
    if (iconPath != null && typeof iconPath === "string" && iconPath != "") {
      icon.style.backgroundImage = `url(${require(`@/theme/assets/icons/${iconPath}`)})`;
      icon.style.width = iconSize;
      icon.style.minWidth = iconSize;
      icon.style.height = iconSize;
      icon.style.minHeight = iconSize;
    } else {
      icon.remove();
    }
  }
});
